import {createSlice} from "@reduxjs/toolkit";
import User from "../../models/User";

const initialState = {
  loading: false,
  data: JSON.parse(JSON.stringify(new User({}))),
  error: "",
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.data = {
        userId: action.payload.userId,
        username: action.payload.username,
        permission: action.payload.permission,
        reset: action.payload.reset,
        token: action.payload.token,
      };
    },
    setToken: (state, action) => {
      state.data.token = action.payload;
    },
    logOut: (state, action) => {
      state.data = initialState.data;
    },
  },
});

export const {setUserData, setToken, logOut} = userDataSlice.actions;

export default userDataSlice.reducer;
